(function () {
  var DESKTOP_VISIBLE = 4;
  var roots = document.querySelectorAll('.eco-home-best-sellers');

  roots.forEach(function (root) {
    var viewport = root.querySelector('[data-eco-home-bs-viewport]');
    var track = root.querySelector('[data-eco-home-bs-track]');
    var prevBtn = root.querySelector('[data-eco-home-bs-prev]');
    var nextBtn = root.querySelector('[data-eco-home-bs-next]');
    var progress = root.querySelector('[data-eco-home-bs-progress]');
    var cards = track ? Array.prototype.slice.call(track.querySelectorAll('.eco-home-best-sellers-card')) : [];
    var total = cards.length;
    var current = 0;
    var raf;

    if (!viewport || !track || !total) return;

    if (progress) {
      progress.innerHTML = '';

      for (var i = 0; i < total; i++) {
        progress.appendChild(document.createElement('span'));
      }
    }

    function isDesktop() {
      return window.matchMedia('(min-width: 768px)').matches;
    }

    function maxIndex() {
      return isDesktop()
        ? Math.max(0, total - DESKTOP_VISIBLE)
        : Math.max(0, total - 1);
    }

    function clampIndex(index) {
      var max = maxIndex();

      if (index < 0) return 0;
      if (index > max) return max;

      return index;
    }

    function getDesktopStep() {
      var first = cards[0];
      var second = cards[1];

      if (!first) return 0;

      var cardW = first.getBoundingClientRect().width;
      var gap = 24;

      if (second) {
        gap = second.getBoundingClientRect().left - first.getBoundingClientRect().right;
      }

      return cardW + gap;
    }

    function getClosestMobileIndex() {
      var trackCenter = track.scrollLeft + track.clientWidth / 2;
      var closestIndex = 0;
      var closestDistance = Infinity;

      cards.forEach(function (card, index) {
        var cardCenter = card.offsetLeft + card.offsetWidth / 2;
        var distance = Math.abs(cardCenter - trackCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function updateControls() {
      var max = maxIndex();

      if (prevBtn) prevBtn.disabled = current <= 0;
      if (nextBtn) nextBtn.disabled = current >= max;

      if (progress) {
        var dots = progress.querySelectorAll('span');

        dots.forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === current);
        });
      }
    }

    function goToDesktop(index) {
      current = clampIndex(index);

      var step = getDesktopStep();
      track.style.transform = 'translateX(' + (-current * step) + 'px)';

      updateControls();
    }

    function goToMobile(index, behavior) {
      current = clampIndex(index);

      var card = cards[current];
      if (!card) return;

      track.style.transform = 'none';

      var targetLeft = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;

      track.scrollTo({
        left: targetLeft,
        behavior: behavior || 'smooth'
      });

      updateControls();
    }

    function goTo(index, behavior) {
      if (isDesktop()) {
        goToDesktop(index);
      } else {
        goToMobile(index, behavior);
      }
    }

    function updateFromMobileScroll() {
      if (isDesktop()) return;

      current = clampIndex(getClosestMobileIndex());
      updateControls();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (!isDesktop()) {
          current = getClosestMobileIndex();
        }

        goTo(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (!isDesktop()) {
          current = getClosestMobileIndex();
        }

        goTo(current + 1);
      });
    }

    track.addEventListener('scroll', function () {
      if (isDesktop()) return;

      cancelAnimationFrame(raf);

      raf = requestAnimationFrame(function () {
        updateFromMobileScroll();
      });
    }, { passive: true });

    window.addEventListener('resize', function () {
      cancelAnimationFrame(raf);

      raf = requestAnimationFrame(function () {
        goTo(current, 'auto');
      });
    });

    goTo(0, 'auto');
  });
})();